import { Injectable } from "@angular/core";
import { LoadRealCostUseCase } from "../../../../domain/use-cases/real-cost/load-real-cost.usecase";
import { SaveMultipliersUseCase } from "../../../../domain/use-cases/real-cost/save-multipliers.usecase";
import { RealCostMultiplier, ResourceCostOverride } from "../../../../domain/models/real-cost.model";
import { RealCostRepository } from "../../../../domain/repositories/real-cost.repository";

@Injectable({
  providedIn: "root",
})
export class RealCostService {
  constructor(
    private loadRealCostUseCase: LoadRealCostUseCase,
    private saveMultipliersUseCase: SaveMultipliersUseCase,
    private repo: RealCostRepository,
  ) { }

    loadRealCostData(
        contractCode: string,
        billingEventId?: number | null
    ) {
        return this.loadRealCostUseCase.execute({
            contractCode,
            billingEventId
        });
    }

  saveMultipliers(contractId: number, multipliers: RealCostMultiplier[] | null, straight40?: boolean | null) {
    return this.saveMultipliersUseCase.execute({ contractId, multipliers, straight40 });
  }

  loadCostOverrides(contractId: number) {
    return this.repo.loadCostOverrides(contractId);
  }

  saveCostOverrides(contractId: number, overrides: ResourceCostOverride[]) {
    return this.repo.saveCostOverrides(contractId, overrides);
  }

  checkPageAccess(ruleCode: string) {
    return this.repo.checkPageAccess(ruleCode);
  }
}